"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const location_filter_checkbox_1 = __importDefault(require("../location-filter-checkbox"));
const location_filter_radio_1 = __importDefault(require("../location-filter-radio"));
const location_search_box_1 = __importDefault(require("../location-search-box"));
const models_1 = require("../../utils/models");
const react_i18next_1 = require("react-i18next");
const location_error_summary_1 = __importDefault(require("../location-error-summary"));
require("./styles.scss");
const LocationSearchboxWrapper = ({ filters, searchParamDefaults, customLocations, customLocationIcon, child, errors, onErrorChange }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    //Initialize state filter values
    const initFilterValues = () => {
        const filtersInitial = {};
        if (filters) {
            for (const filter of filters) {
                if (filter.optionParamMap) {
                    for (const param of Object.values(filter.optionParamMap)) {
                        filtersInitial[param] = '0';
                    }
                }
            }
        }
        if (searchParamDefaults) {
            for (const [key, value] of searchParamDefaults) {
                filtersInitial[key] = value;
            }
        }
        return filtersInitial;
    };
    //State for filter values, passed as props to LocationSearchBox for use in search functions
    const [filterValues, setFilterValues] = (0, react_1.useState)(initFilterValues());
    const [errorState, setErrorState] = (0, react_1.useState)(errors !== null && errors !== void 0 ? errors : []);
    (0, react_1.useEffect)(() => {
        setErrorState(errors !== null && errors !== void 0 ? errors : []);
    }, [errors]);
    // Sends errors up to parent component for Google Analytics
    (0, react_1.useEffect)(() => {
        if (onErrorChange && errorState) {
            onErrorChange(errorState);
        }
    }, [errorState, onErrorChange]);
    //Updates param value in filterValues state
    const handleFilterChange = (param, value) => {
        setFilterValues((prev) => (Object.assign(Object.assign({}, prev), { [param]: value })));
    };
    //Update Error value in errorState if exists, otherwise adds new Error
    const handleErrorChange = (0, react_1.useCallback)((newError) => {
        const updatedErrors = [...errorState];
        const index = errorState.findIndex((err) => err.id === newError.id);
        if (index === -1) {
            setErrorState(prevState => [...prevState, newError]);
        }
        else {
            updatedErrors[index] = newError;
            setErrorState(updatedErrors);
        }
    }, [errorState, setErrorState]);
    //Update Error value in errorState if exists, otherwise adds new Error
    const removeError = (errorId) => {
        const updatedErrors = [...errorState];
        const index = updatedErrors.findIndex((err) => err.id === errorId);
        if (index !== -1) {
            updatedErrors.splice(index, 1);
            setErrorState(updatedErrors);
        }
    };
    //Update params when prop changes
    (0, react_1.useEffect)(() => {
        if (searchParamDefaults) {
            for (const [key, value] of searchParamDefaults) {
                handleFilterChange(key, value);
            }
        }
    }, [searchParamDefaults]);
    //Update errors when prop change
    (0, react_1.useEffect)(() => {
        if (errors) {
            for (const error of errors) {
                handleErrorChange(error);
            }
        }
    }, [errors]);
    //Generate filter components
    const renderFilters = (filter) => {
        if (filter.type === models_1.Filter.Checkbox && filter.options && filter.optionParamMap) {
            return ((0, jsx_runtime_1.jsx)(location_filter_checkbox_1.default, { title: filter.title, options: filter.options, optionParamMap: filter.optionParamMap, onChange: handleFilterChange }));
        }
        else if (filter.options && filter.optionParamMap) {
            return ((0, jsx_runtime_1.jsx)(location_filter_radio_1.default, { title: filter.title, options: filter.options, optionParamMap: filter.optionParamMap, onChange: handleFilterChange }));
        }
        //else multiselect
    };
    const errorSummaryRef = (0, react_1.useRef)(null);
    const errorSummaryComponent = (0, react_1.useMemo)(() => {
        return (0, jsx_runtime_1.jsx)(location_error_summary_1.default, { errorSummaryRef: errorSummaryRef, customErrors: errorState });
    }, [errorState]);
    const [childError, setChildError] = (0, react_1.useState)();
    const [serviceError, setServiceError] = (0, react_1.useState)(false);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [Object.keys(errorState).length > 0 && errorSummaryComponent, (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "wrapper-so-search ontario-row ontario-margin-bottom-0-!" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "ontario-small-12 ontario-medium-4 ontario-columns" }, { children: (0, jsx_runtime_1.jsx)(location_search_box_1.default, { searchParams: new URLSearchParams(filterValues), customLocations: customLocations, customLocationIcon: customLocationIcon, hideMapImg: true, hideButton: true, hideErrorBanner: true, errorBannerRef: errorSummaryRef, childError: childError, setServiceError: setServiceError, serviceError: serviceError, updateErrors: handleErrorChange, removeError: removeError }) })), (0, jsx_runtime_1.jsx)("div", { children: child && child(handleErrorChange, removeError, setChildError, serviceError, setServiceError) }), (0, jsx_runtime_1.jsx)("hr", { className: "searchbox-divider" }), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "ontario-small-12 ontario-column" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "filters-holder" }, { children: filters === null || filters === void 0 ? void 0 : filters.map((filter) => (renderFilters(filter))) })), (0, jsx_runtime_1.jsx)("button", Object.assign({ form: "location-search-box-form", className: "ontario-button ontario-button--primary ontario-margin-top-8-!", type: "submit" }, { children: t("searchBox.button") }))] }))] }))] }));
};
exports.default = LocationSearchboxWrapper;
